import React from 'react'

export const marketAlertContent = [
  {
    market: 'wa',
    heading: 'Riparide has launched in Washington State!',
    text: (
      <>
        We now have over 200 Washington listings on Riparide and we’re excited
        to add even more! Check out{' '}
        <a href="/washington">Riparide Washington</a> to see what we’ve curated
        so far, then sign up to become one of our pioneer hosts and start
        delivering soul-fulfilling short nature escapes.
      </>
    ),
  },
  {
    market: 'or',
    heading: 'Riparide is coming to Oregon!',
    text: (
      <>
        We have chosen <strong>Oregon</strong> as one of our first locations in
        the <strong>United States</strong> and we couldn’t be more excited! List
        your property now and become one of our first hosts in the US to deliver
        soul-fulfilling escapes.
      </>
    ),
  },
  {
    market: 'ca',
    heading: 'Riparide is coming to California!',
    text: (
      <>
        We have chosen <strong>California</strong> as one of our first locations
        in the <strong>United States</strong> and we couldn’t be more excited!
        List your property now and be one of the first U.S. Hosts to provide
        soul-fulfilling escapes.
      </>
    ),
  },
]
